export default "__VITE_ASSET__CzsRuT3s__"